import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import MainTopbar from 'components/topbar/main/main_topbar'
import mainTopbarActions from 'redux/actions/mainTopbarActions'
import generalActions from 'redux/actions/generalActions'
import routeActions from 'redux/actions/routeActions'
import mainTopbarSelector from 'redux/selectors/topbar/main_topbar_selector'
import myLibraryActions from 'redux/actions/my_library_actions'
import quickLaunchActions from 'redux/actions/quickLaunchActions'
import Add from 'components/topbar/main/add/add'
import QuickLaunch from 'components/topbar/main/quick_launch/quickLaunch'
import Avatar from 'components/topbar/main//avatar/avatar'
import Cart from 'components/topbar/main/cart/cart'
import NavigationMenu from 'containers/navigation_menu/container'

class MainTopbarContainer extends PureComponent {

	createAdd() {
		return (
			<Add
				handlePlusIconToggled={this.props.actions.handlePlusIconToggled}
				shouldShowTooltipGSCreateLesson={
					this.props.shouldShowTooltipGSCreateLesson
				}
				shouldShowFolderDropdownOption={
					this.props.shouldShowFolderDropdownOption
				}
				shouldShowAddButton={this.props.shouldShowAddButton}
				addLessonHandler={this.props.actions.createLesson}
				addFolderHandler={this.props.actions.addFolder}
				addGoogleSlideHandler={
					this.props.actions.createGoogleDriveLesson
				}
				canCreateInteractiveVideo={this.props.canCreateInteractiveVideo}
				addInteractiveVideoHandler={
					this.props.actions.createInteractiveVideo
				}
				shouldUpdateCreateLesson={
					this.props.shouldUpdateCreateLesson
				}
			/>
		)
	}

	createQuickLaunch() {
		return (
			<QuickLaunch
				quickLaunchData={this.props.quickLaunchData}
				handleQuickLaunchIconToggled={
					this.props.actions.handleQLIconToggled
				}
				onDrawItSelection={this.props.actions.handleQLDrawItSelection}
				onOeqSelection={this.props.actions.handleQLOeqSelection}
				onCollaborateSelection={
					this.props.actions.handleQLCollaborateSelection
				}
				onTimerSelection={this.props.actions.handleQLTimerSelection}
			/>
		)
	}

	createAvatar() {
		return (
			<Avatar
				userImage={this.props.userImage}
				onClick={this.props.actions.toggleSidebar}
			/>
		)
	}

	createNavigationMenu = () => <NavigationMenu />

	createCart() {
		return (
			<Cart
				goToCheckout={this.props.actions.goToCheckout}
			/>
		)
	}

	render() {
		// TODO: The Avatar component must be passed as prop to the MainTopbar component
		// because React Native is still using it
		// Remove avatar prop and TOGGLE_SIDEBAR action when doing nav stack on the RN side
		return (
			<MainTopbar
				initialize={this.props.actions.initialize}
				handleHomeSelection={this.props.actions.homeSelected}
				handleLogoSelection={this.props.actions.logoSelected}
				shouldShowTooltips={this.props.shouldShowTooltips}
				add={this.createAdd()}
				quickLaunch={this.createQuickLaunch()}
				cart={
					this.props.shouldShowCartButton
						? this.createCart() : null
				}
				avatar={this.createAvatar()}
				navigationMenu={this.createNavigationMenu()}
				shouldUpdateNavTopbar={this.props.shouldUpdateTopbar || this.props.shouldUpdateNavTopbar}
			/>
		)
	}
}

function mapStateToProps(state) {
	return mainTopbarSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		initialize: mainTopbarActions.initialize,
		createLesson: mainTopbarActions.createLesson,
		addFolder: myLibraryActions.addFolder,
		toggleSidebar: generalActions.toggleSidebar,
		logoSelected: mainTopbarActions.logoSelected,
		homeSelected: mainTopbarActions.homeSelected,
		goToCheckout: routeActions.goToCheckout,
		createGoogleDriveLesson: mainTopbarActions.createGoogleDriveLesson,
		handlePlusIconToggled: mainTopbarActions.plusIconToggled,
		handleQLIconToggled: mainTopbarActions.quickLaunchIconToggled,
		handleQLDrawItSelection: quickLaunchActions.createDrawIt,
		handleQLOeqSelection: quickLaunchActions.createOeq,
		handleQLCollaborateSelection: quickLaunchActions.createCollaborate,
		handleQLTimerSelection: quickLaunchActions.createTimer,
		createInteractiveVideo: mainTopbarActions.createInteractiveVideo,
	}, dispatch)
}

MainTopbarContainer.propTypes = {
	actions: PropTypes.object.isRequired,
	shouldShowTooltips: PropTypes.bool.isRequired,
	quickLaunchData: PropTypes.object.isRequired,
	shouldShowCartButton: PropTypes.bool,
	userImage: PropTypes.string,
	shouldShowTooltipGSCreateLesson: PropTypes.bool,
	shouldShowFolderDropdownOption: PropTypes.bool,
	shouldShowAddButton: PropTypes.bool,
	toggleSidebar: PropTypes.func,
	canCreateInteractiveVideo: PropTypes.bool,
	shouldUpdateNavTopbar: PropTypes.bool,
	shouldUpdateTopbar: PropTypes.bool,
	shouldUpdateCreateLesson: PropTypes.bool,
}

MainTopbarContainer.defaultProps = {
	shouldUpdateTopbar: false,
	shouldUpdateCreateLesson: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(
	MainTopbarContainer
)
